export default __webpack_public_path__ + "static/gatsby_github_get_pat1-e59576bd4c37eef53c9cc9d9afb71e47.png";